module.exports = __webpack_public_path__ + "media/images/plus_icon-9258709d1b502e5895e0b2184f8b1525.svg";